import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useMemo,
  useContext
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  httpGetSellerCentralManageReports,
  httpPostSellerCentralManageReports,
} from "../../service/httpClient";
import { getUserRolePermission } from "../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../constants/RolePermissionConstants";
import PageNotFound from "../Routes/PageNotFound";
import { getDisableEnableConfig } from "../VendorOnboarding/OnboardingHelper";
import {
  DISABLED_FLAG,
  ENABLED_FLAG,
  EXTERNAL_VENDOR_GENERIC,
} from "../../constants/Constants";
import LoadingOverlay from "react-loading-overlay";
import "./ManageSellerReports.css";
import { useVendorProfileLoader } from "../Common/CustomHooks/useVendorProfileLoader";
import AppContext from '../../context/appcontext';
import {SELLERCENTRAL_ADMIN} from '../../constants/Constants';
import Cookie from "js-cookie";

const defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
};

const ManageSellerReports = () => {
  const context = useContext(AppContext);
  useVendorProfileLoader();
  const [columnWidth, setColumnWidth] = useState(0);
  const [agGridHeight, setAgGridHeight] = useState(0);
  const gridRef = useRef();
  const [modifiedCheckBox, setModifiedCheckBox] = useState([]);
  const [disableSaveBtn, setDisableSaveBtn] = useState(true);
  const [showPopUp, setShowPopUp] = useState(false);
  const handleClosePopUp = () => setShowPopUp(false);
  const navAndheaderHeight = 150;
  const agGridIDcolumnWidth = 80;
  const [enableSellerHubFeature, setEnableSellerHubFeature] = useState();
  const [isLoading, setIsLoading] = useState(true);
  useLayoutEffect(() => {
    function updateColumnWidth() {
      setColumnWidth(Math.round((window.innerWidth - agGridIDcolumnWidth) / 7));
      setAgGridHeight(window.innerHeight - navAndheaderHeight);
    }
    window.addEventListener("resize", updateColumnWidth);
    updateColumnWidth();
    return () => window.removeEventListener("resize", updateColumnWidth);
  }, []);

  const ActiveCheckBoxRenderer = (props) => {
    const checkedHandler = (event) => {
      let checked = event.target.checked;
      let colId = props?.column?.colId;
      props.node.setDataValue(colId, checked);
    };
    const changeHandler = (event) => {
      let activeCheckBox = props?.node?.data;
      let removeDuplicate = [];
      setDisableSaveBtn(false);
      if (modifiedCheckBox?.length > 0) {
        removeDuplicate = modifiedCheckBox.filter((obj) => {
          if (obj?.shop_id !== activeCheckBox?.shop_id) return obj;
        });
        let dataCol = [...removeDuplicate, activeCheckBox];
        setModifiedCheckBox(dataCol);
      } else {
        let dataCol = [...modifiedCheckBox, activeCheckBox];
        setModifiedCheckBox(dataCol);
      }
    };
    return (
      props?.node?.data?.orgHierarchy.length === 1 && (
        <label className="manage-reports-checkbox">
          <input
            type="checkbox"
            checked={props.value}
            onChange={changeHandler}
            onClick={checkedHandler}
          />
        </label>
      )
    );
  };

  const [manageSellerResponse, setManageSellerResponse] = useState([]);
  const [rowData, setRowData] = useState([]);
  const columnDefs = [
    { field: "shop_id", headerName: "Shop Id", width: columnWidth },
    { field: "company_name", headerName: "Company Name", width: columnWidth },
    { field: "first_name", headerName: "First Name", width: columnWidth },
    { field: "last_name", headerName: "Last Name", width: columnWidth },
    { field: "email", headerName: "Email", width: columnWidth },
    { field: "role", headerName: "Role", width: columnWidth },
    {
      headerName: "Seller Hub Access",
      field: "active",
      cellRenderer: ActiveCheckBoxRenderer,
      width: columnWidth,
    },
  ];
  const formatManageResponseData = (data) => {
    let hierarchyFormat = [];
    data.map((company) => {
      hierarchyFormat.push({
        orgHierarchy: [Number(company?.id)],
        id: company?.id,
        shop_id: company?.shop_id,
        company_name: company?.company_name,
        active: company?.active,
      });
      let users_list =
        company?.users_list?.length > 0 ? company?.users_list : [];
      users_list.map((user, index) => {
        user.orgHierarchy = [Number(company?.id), index];
        user.role = user.role === EXTERNAL_VENDOR_GENERIC ? "Generic" : "Admin";
        hierarchyFormat.push(user);
      });
    });
    return hierarchyFormat;
  };
  useEffect(() => {
    if (
      getUserRolePermission(
        RolePermissionConstants?.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
        RolePermissionConstants?.ALL
      ) === RolePermissionConstants.EDIT
    ) {
      httpGetSellerCentralManageReports()
        .then((response) => {
          let res = response?.data.map((a) => {
            a.initialActive = a.active;
            return { ...a };
          });
          let manageResponseData = JSON.parse(JSON.stringify(res));
          manageResponseData =
            manageResponseData.length > 0 ? manageResponseData : [];
          setManageSellerResponse(manageResponseData);
          setRowData(formatManageResponseData(manageResponseData));
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    getDisableEnableConfig("sellerCentral", (response) => {
      setEnableSellerHubFeature(response);
    });
  }, []);

  const manageReportsSaveHandler = () => {
    let updates = [];
    updates = modifiedCheckBox.filter((a) => {
      if (a.active !== a.initialActive) {
        return { ...a };
      }
    });
    updates = updates.map((a) => {
      let obj = { shop_id: a.shop_id, active: a.active,userEmail: Cookie.get('email') };
      return obj;
    });
    httpPostSellerCentralManageReports(updates)
      .then((response) => {
        let res = response?.data?.map((a) => {
          a.initialActive = a.active;
          return { ...a };
        });
        setManageSellerResponse(JSON.parse(JSON.stringify(res)));
        setRowData(formatManageResponseData(JSON.parse(JSON.stringify(res))));
        setDisableSaveBtn(true);
        setShowPopUp(true);
        setModifiedCheckBox([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const manageReportsCancelHandler = () => {
    setRowData(
      formatManageResponseData(manageSellerResponse).map((a) => {
        return { ...a };
      })
    );
    setDisableSaveBtn(true);
    setModifiedCheckBox([]);
  };
  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "#",
      width: agGridIDcolumnWidth,
      cellRendererParams: {
        suppressCount: true,
      },
    };
  }, []);
  const getDataPath = useMemo(() => {
    return (data) => {
      return data?.orgHierarchy;
    };
  }, []);
  return (
    <>
      {getUserRolePermission(
        RolePermissionConstants?.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
        RolePermissionConstants?.ALL
      ) === RolePermissionConstants.EDIT &&
      enableSellerHubFeature === ENABLED_FLAG ? (
        <>
          <LoadingOverlay active={isLoading} spinner>
            <div
              className="ag-theme-balham manageReportsTable"
              style={{ height: agGridHeight }}
            >
              <AgGridReact
                ref={gridRef}
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                rowData={rowData}
                multiSortKey={"ctrl"}
                maintainColumnOrder={true}
                rowSelection="multiple"
                paginationPageSize="50"
                pagination={true}
                enableRangeSelection={true}
                autoGroupColumnDef={autoGroupColumnDef}
                treeData={true}
                animateRows={true}
                getDataPath={getDataPath}
                suppressHorizontalScroll={true}
                suppressDragLeaveHidesColumns={true}
                getRowHeight={30}
                getRowStyle={(params) => {
                  if (
                    params?.node?.uiLevel === 1 &&
                    params?.data?.is_active === "false"
                  ) {
                    return { background: "#E3D1CD", color: "#808080" };
                  }
                }}
              />
            </div>
            <div className="manage-reports-bottom">
              <Button
                className="button-primary-md"
                type="submit"
                onClick={manageReportsSaveHandler}
                disabled={disableSaveBtn}
              >
                Save
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                className="button-later-md"
                onClick={manageReportsCancelHandler}
              >
                Cancel
              </Button>
            </div>
            <Modal
              show={showPopUp}
              onHide={handleClosePopUp}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Data saved successfully!</Modal.Title>
              </Modal.Header>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClosePopUp}>
                  OK
                </Button>
              </Modal.Footer>
            </Modal>
          </LoadingOverlay>
        </>
      ) : enableSellerHubFeature === DISABLED_FLAG ? (
        <PageNotFound></PageNotFound>
        ) : (
          context?.roles?.roleName != SELLERCENTRAL_ADMIN && (<div className="seller-hub-no-access">
            You do not have access to this site.
          </div>)
        ) }
    </>
  );
};
export default ManageSellerReports;
